module.exports = __webpack_public_path__ + "media/images/webpage/hotels/theme/cover-kyoto-1-0b3650cb66aae59ac45e0e75c955d014.webp";